import type { TOC } from '@ember/component/template-only'
import { t } from 'ember-intl'
import formatValue from 'teacher-ui-client/helpers/format-value'
import type { ReportData } from 'teacher-ui-client/components/reporting/reading-eggspress/read-aloud-fluency/student/overview/report-loader'
import { ThStandard } from 'teacher-ui-client/components/th/standard'

interface Signature {
  Element: HTMLTableElement
  Args: {
    overviewData: ReportData['overview']
    isReloading?: boolean
  }
}

export const Report: TOC<Signature> = <template>
  <table class="border-oceany-blue-150 border-b text-center" ...attributes>
    <thead class="bg-oceany-blue-50">
      <tr class="divide-x divide-white">
        <ThStandard data-test-th="total_assignments_completed" class="w-1/3">{{t
            "reporting.totalAssignmentsCompleted"
          }}</ThStandard>
        <ThStandard data-test-th="average_lexile_formatted" class="w-1/3">{{t
            "reporting.averageLexileLevel"
          }}</ThStandard>
        <ThStandard data-test-th="lexile_range_formatted" class="w-1/3">{{t "reporting.lexileRange"}}</ThStandard>
      </tr>
    </thead>
    <tbody class={{if @isReloading "opacity-50"}}>
      <tr>
        <td data-test-cell="total_assignments_completed" class="p-3">{{formatValue
            @overviewData.total_assignments_completed
          }}</td>
        <td data-test-cell="average_lexile_formatted" class="p-3">{{formatValue
            @overviewData.average_lexile_formatted
          }}</td>
        <td data-test-cell="lexile_range_formatted" class="p-3">{{formatValue
            @overviewData.lexile_range_formatted
          }}</td>
      </tr>
    </tbody>
  </table>
</template>
